export enum CurrencyCode {
    usd = 'USD',
    cad = 'CAD',
    gbp = 'GBP',
    eur = 'EUR',
    jpy = 'JPY',
    brl = 'BRL',
    inr = 'INR',
    aud = 'AUD',
}
